import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { NavController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { timeout } from 'rxjs/operators';

//import { Plugins } from '@capacitor/core';
//const { Geolocation } = Plugins;


@Injectable({
  providedIn: 'root'
})
export class MaprenderService {
  public gpsStatus: string;

  public mapCurrent: string;
  public mapCurrentPos: any = [-16.4958187, -68.1337793];

  public mapChanged = new Subject();
  public posChanged = new Subject();


  constructor(
    public http: HttpClient,
    //public navCtrl: NavController,
    public router: Router
  ) { }

  mapRefresh(state: string) {
    this.mapCurrent = state;
    this.mapChanged.next(this.mapCurrent);
    console.log('mapStateCurrent =>', this.mapCurrent);
    return this.mapCurrent;
  }

  mapDestroyNgo(mapCurrent?) {
    this.mapRefresh(mapCurrent);
  }

  async getCurrentLocation() {
    /*  const coordinates = await Geolocation.getCurrentPosition({
       enableHighAccuracy: true, // Alta precisión
       maximumAge: 0, // No queremos caché
       timeout: 5000 // Esperar solo 5 segundos
     });
     this.mapCurrentPos = [coordinates.coords.latitude, coordinates.coords.longitude];
     console.log('mapCurrentPos', this.mapCurrentPos);
     this.posChanged.next(this.mapCurrentPos); */
  };

  watchPosition() {
   /*   Geolocation.watchPosition({}, (position, err) => {
      if (err) {
        this.gpsStatus = 'blocked';
      }
      else {
        this.gpsStatus = 'granted';
      }
    }) */
  }

}
